export const PROCESS_NAMES = {
    'salesorder-in-shop-scan': 'Clinic 3D-Scan',
    'salesorder-in-shop-scan-new': 'Clinic 3D-Scan New',
    'salesorder-check-in': 'Clinic Check-In',
    'salesorder-escalation': 'Escalation',
    'salesorder-refinement-set': 'Refinement (Set)',
    'salesorder-refinement-booking': 'Refinement (Booking)',
    'salesorder-refinement-shop': 'Refinement (Shop Scan)',
    'salesorder-refinement-shop-new': 'Refinement (Shop Scan New)',
    'salesorder-refinement-production': 'Refinement Treatment',
    'salesorder-retainer': 'Retainer',
    'salesorder-retainer-new': 'Retainer New',
    'salesorder-set': 'Set',
    'salesorder-shop-scan': 'Shop Scan',
    'salesorder-shop-scan-new': 'Shop Scan New',
    'salesorder-treatment': 'Treatment',
    'salesorder-treatment-new': 'Treatment New',
    'salesorder-end-of-treatment': 'End Of Treatment',
    'salesorder-aligner-reproduction': 'Aligner Reproduction',
    'process-implant-3dscan': 'Implant 3D-Scan',
    'process-implant-plan': 'Implant Plan',
    'process-implant-treatment': 'Implant Treatment',
    'process-retainer-refinement': 'Retainer Refinement',
    'process-retainer-refinement-new': 'Retainer Refinement New',
    'process-partial-refund': 'Partial Refund',
}

export const PROCESS_NAME_SELECT = Object.keys(PROCESS_NAMES).map(processName => ({
    id: processName,
    value: PROCESS_NAMES[processName],
}))


const DEBUG_MODE = false


export const renderProcessName = (processName) => {
    return PROCESS_NAMES[processName]
}

export const renderTaskName = (taskName) => {
    if (!taskName) {
        return ''
    }
    return DEBUG_MODE ? taskName : taskName.replace(/_/g, ' ')
}


export const renderEventName = (eventName) => {
    if (!eventName) {
        return ''
    }
    return DEBUG_MODE ? eventName : eventName.replace(/_/g, ' ')
}

export const renderStateName = (stateName) => {
    if (!stateName) {
        return ''
    }
    return DEBUG_MODE ? stateName : stateName.replace(/_/g, ' ')
}

export const renderRoleName = (roleName) => {
    if (!roleName) {
        return ''
    }
    roleName = roleName.join(',')
    return DEBUG_MODE ? roleName : roleName.replace(/_/g, ' ')
}



// WEBPACK FOOTER //
// ./src/modules/process/util/names.js